// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @constants
const { getTranslatedRoad } = require('constants/typeOfRoads');
// @Utilities
const { toCamelCase } = require('utilities/stringHelper');

const RetailLoanPickupAddress = ({ immOffice }) => {
    const immAddress = immOffice.get('pickup_place_address');
    const typeOfRoads = toCamelCase(getTranslatedRoad(immAddress.get('road_type')) || '');

    return (
        <React.Fragment>
            <div>
                {`${immOffice.get('pickup_place_name')}`}
            </div>
            <div>
                {`${typeOfRoads} ${immAddress.get('road_name')} `}
                {`${immAddress.get('road_number')}, ${immAddress.get('road_additional_info')} ${immAddress.get('road_locality')}`}
            </div>
        </React.Fragment>
    );
}

RetailLoanPickupAddress.propTypes = {
    immOffice: PropTypes.object.isRequired
};

module.exports = RetailLoanPickupAddress;
